import React from 'react';

import TrunkIdentityFields from './TrunkIdentityFields';

function TrunkAuth(props) {
  const { changeValues, tenants, values = {}, identity, batchMode = false } = props;

  return (
    <div>
      <section className="trunk-section-card">
        <h2 className="trunk-section-title">Identificação</h2>
        <div className="trunk-form-grid">
          <TrunkIdentityFields identity={identity} tenants={tenants} values={values} changeValues={changeValues} />
          <div className="form-field">
            <label className="form-label">Modo</label>
            <select className="form-select" name="mode" value={values.mode || ''} onChange={(e) => changeValues(e.target)} disabled={batchMode} title={batchMode ? 'Faixa de DDR cria somente troncos unidirecionais' : ''}>
              <option value="">Selecione</option>
              <option value="bidirecional">Bidirecional</option>
              <option value="unidirecional">Unidirecional</option>
            </select>
          </div>
          {batchMode && (
            <div className="form-field">
              <label className="form-label">Tronco Inicial</label>
              <input className="form-input" name="trunkNumber" type="text" defaultValue={values.trunkNumber || ''} onChange={(e) => changeValues(e.target)} placeholder="1431110000" />
              <p name="trunkNumber-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
            </div>
          )}
          {batchMode && (
            <div className="form-field">
              <label className="form-label">Quantidade</label>
              <input className="form-input" name="qtt" type="number" min="1" defaultValue={values.qtt || ''} onChange={(e) => changeValues(e.target)} placeholder="50" />
              <p name="qtt-invalid-data" className="form-error is-hidden">Informe uma quantidade válida.</p>
            </div>
          )}
          <div className="trunk-grid-span-2" id="realNumber-field-auth" style={batchMode ? { display: 'flex' } : { display: 'none' }}>
            <div className="form-field">
              <label className="form-label">{batchMode ? 'Número Real Inicial' : 'Número Real'}</label>
              <input className="form-input" name="realNumber" type="text" defaultValue={values.realNumber || ''} onChange={(e) => changeValues(e.target)} placeholder="11999887766" />
              <p name="realNumber-invalid-data" className="form-error is-hidden">Campo obrigatório para modo unidirecional!</p>
            </div>
          </div>
        </div>
      </section>

      <section className="trunk-section-card">
        <h2 className="trunk-section-title">Conexão e autenticação</h2>
        <div className="trunk-form-grid">
          <div className="form-field">
            <label className="form-label">Nome de Usuário</label>
            <input className="form-input" name="authUsername" type="text" defaultValue={values.authUsername || ''} onChange={(e) => changeValues(e.target)} placeholder="a1bc56n" />
            <p name="authUsername-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
          </div>
          <div className="form-field">
            <label className="form-label">Senha</label>
            <input className="form-input" name="password" type="text" defaultValue={values.password || ''} onBlur={(e) => changeValues(e.target)} placeholder="Mínimo 6 carac." />
            <p name="password-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
          </div>
          <div className="form-field">
            <label className="form-label">IP SIP (Operadora)</label>
            <input className="form-input" name="ipSbcTrunk" type="text" defaultValue={values.ipSbcTrunk || ''} onBlur={(e) => changeValues(e.target)} placeholder="1.0.0.1" />
            <p name="ipSbcTrunk-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
          </div>
          <div className="form-field trunk-grid-span-2">
            <div className="codec-group">
              <div className="codec-group-title">Codec</div>
              <div className="codec-options">
                <div className="codec-option">
                  <label>G.729</label>
                  <input className="codec-checkbox" name="codec" type="checkbox" value="g729" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('g729') : values.codec.toString().includes('g729'))} onChange={(e) => changeValues(e.target)} />
                </div>
                <div className="codec-option">
                  <label>ALAW</label>
                  <input className="codec-checkbox" name="codec" type="checkbox" value="alaw" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('alaw') : values.codec.toString().includes('alaw'))} onChange={(e) => changeValues(e.target)} />
                </div>
                <div className="codec-option">
                  <label>ULAW</label>
                  <input className="codec-checkbox" name="codec" type="checkbox" value="ulaw" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('ulaw') : values.codec.toString().includes('ulaw'))} onChange={(e) => changeValues(e.target)} />
                </div>
                <div className="codec-option">
                  <label>H.264</label>
                  <input className="codec-checkbox" name="codec" type="checkbox" value="h264" defaultChecked={values.codec && (Array.isArray(values.codec) ? values.codec.includes('h264') : values.codec.toString().includes('h264'))} onChange={(e) => changeValues(e.target)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="trunk-section-card">
        <h2 className="trunk-section-title">Configurações avançadas</h2>
        <div className="trunk-form-grid">
          <div className="form-field">
            <label className="form-label">Monitoramento (qualify, seg)</label>
            <input className="form-input" name="qualifyFrequency" type="number" min="0" max="86400" step="1" value={values.qualifyFrequency ?? 120} onChange={(e) => changeValues(e.target)} />
            <p className="form-help">Intervalo dos OPTIONS para verificar se o tronco está disponível. Use 0 para desativar.</p>
            <p name="qualifyFrequency-invalid-data" className="form-error is-hidden">Informe um inteiro entre 0 e 86400.</p>
          </div>
          <div className="form-field">
            <label className="form-checkbox-label">
              <input type="checkbox" name="sendRegister" checked={values.sendRegister !== false} onChange={(e) => changeValues(e.target)} />
              {' '}Enviar registro (register)
            </label>
            <label className="form-label">Reenvio de registro (seg)</label>
            <input className="form-input" name="regExpiration" type="number" min="60" max="7200" step="1" value={values.regExpiration ?? 3600} disabled={values.sendRegister === false} onChange={(e) => changeValues(e.target)} />
            <p className="form-help">
              {values.sendRegister === false
                ? 'Sem registro: o tronco não envia REGISTER. Chamadas de entrada dependem do modo Bidirecional (identificação por IP).'
                : 'Intervalo solicitado ao provedor para renovar o registro SIP.'}
            </p>
            <p name="regExpiration-invalid-data" className="form-error is-hidden">Informe um inteiro entre 60 e 7200.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TrunkAuth;
